import OrganisationLayout from "../layout/OrganisationLayout";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const organisationRows = [
  {
    name: "Northgate College",
    joinedPlatform: "12 Jan 2026",
    joinedGroup: "04 Apr 2026",
    teachers: 34,
  },
  {
    name: "Riverside School",
    joinedPlatform: "08 Nov 2025",
    joinedGroup: "04 Apr 2026",
    teachers: 28,
  },
];

export default function OrganisationGroupsMemberOrganisations() {
  return (
    <OrganisationLayout>
      <Container fluid>
        <div className="heading-top mt-5 mb-2">
          <h2>Member Organisations</h2>
        </div>
        <Row>
          <Col lg={4}>
            <div className="organisation-search-shell">
              <input type="text" placeholder="Search" />
            </div>
          </Col>
          <Col lg={8} className="create-new-btn d-flex justify-content-end">
            <button className="cmn-pink">Invite Member Organisation</button>
          </Col>
        </Row>
        <section className="organisation-groups-table-shell organisation-groups-table-shell-space">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Joined Peerscroller</th>
                <th>Joined Group</th>
                <th>Teachers</th>
              </tr>
            </thead>
            <tbody>
              {organisationRows.map((row) => (
                <tr key={row.name}>
                  <td>{row.name}</td>
                  <td>{row.joinedPlatform}</td>
                  <td>{row.joinedGroup}</td>
                  <td>{row.teachers}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      </Container>
    </OrganisationLayout>
  );
}
